import { ComponentProps } from 'react';
import { clsx } from 'clsx';

export interface OpenQuoteBaseFormProps extends ComponentProps<'form'> {}
export const OpenQuoteBaseForm = ({
  className,
  children,
  ...props
}: OpenQuoteBaseFormProps) => {
  return (
    <form
      className={clsx(
        className,
        'flex flex-col rounded bg-background-base-surface-2 p-6 shadow',
      )}
      {...props}
    >
      {children}
    </form>
  );
};
